import * as types from '../constants/actionTypes';

export default(action) => {

    switch (action.type) {
        case types.SET_TECH_STATUS_READY:
            return true;
        case types.SET_TECH_STATUS_IN_ROUTE:
            return true;
        case types.SET_TECH_STATUS_ON_JOB:
            return true;
        case types.SET_TECH_STATUS_UNDO_ON_JOB:
            return true;
        case types.SET_TECH_STATUS_UNDO_IN_ROUTE:
            return true;
        case types.SET_TECH_STATUS_ON_BREAK:
            return true;
        case types.SET_TECH_STATUS_OFF_BREAK:
            return true;
        case types.SET_TECH_STATUS_NOT_READY:
            return true;
        case types.GET_TECH_STATUS_STARTED:
            return true;   
        default:
            return false;

    }

};


// WEBPACK FOOTER //
// ./src/status/statusEventCheck.js